import { render, staticRenderFns } from "./ProductCardSlider.vue?vue&type=template&id=40a4a472"
import script from "./ProductCardSlider.vue?vue&type=script&lang=js"
export * from "./ProductCardSlider.vue?vue&type=script&lang=js"
import style0 from "./ProductCardSlider.vue?vue&type=style&index=0&id=40a4a472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports